var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 3.33337H11.6667C7.06429 3.33337 3.33333 7.06433 3.33333 11.6667V28.3334C3.33333 32.9357 7.06429 36.6667 11.6667 36.6667H28.3333C32.9357 36.6667 36.6667 32.9357 36.6667 28.3334V11.6667C36.6667 7.06433 32.9357 3.33337 28.3333 3.33337Z",
    strokeWidth: 1.22686,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 18.95C26.8724 20.3371 26.6354 21.7537 25.9896 22.9984C25.3438 24.243 24.3219 25.2524 23.0694 25.8828C21.8168 26.5132 20.3974 26.7327 19.013 26.5099C17.6285 26.2871 16.3496 25.6335 15.3581 24.6419C14.3665 23.6504 13.7129 22.3715 13.4901 20.987C13.2673 19.6026 13.4868 18.1832 14.1172 16.9306C14.7477 15.6781 15.757 14.6562 17.0016 14.0104C18.2463 13.3646 19.6629 13.1277 21.05 13.3333C22.4649 13.5432 23.7748 14.2025 24.7862 15.2139C25.7976 16.2253 26.4569 17.5351 26.6667 18.95Z",
    strokeWidth: 1.22686,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 10.8333H29.1833",
    strokeWidth: 1.22686,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0c63b6e54c9eae3f5ca8aca32a32eb20.svg";
export { ForwardRef as ReactComponent };